/**
 * Check if current environment is browser.
 */
function isBrowser(): boolean {
    return typeof window !== 'undefined'
}

export { isBrowser }
